import React from 'react';

import { ConfirmDialog } from '@gogame/components';
import { LegacyTextList } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { archiveConcept } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';

import { archive } from '../queryKeyFactory';

export const useBatchArchive = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(archive(), archiveConcept, {
    successMessage: (_data, variables) => {
      return `${variables.ids.length} Concepts was archived`;
    },
  });

  const handleAction = async (rows) => {
    const data = rows.map(({ id, name }) => ({ id, name }));
    const ids = data.map(({ id }) => id);
    await showModal({
      title: `Archive Concept(s)?`,
      confirmActionLabel: 'Archive',
      children: (
        <LegacyTextList
          data={data}
          limit={5}
          unitsName={'Concepts'}
          position={'top'}
        />
      ),
    });
    await removeMutation.mutateAsync({ ids });
  };

  return [handleAction, removeMutation];
};
